import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DeleteService } from 'src/app/features/delete/services/delete.service';
import { User } from '../../models/User';

@Component({
  selector: 'app-delete-user-confirmation-modal',
  templateUrl: './delete-user-confirmation-modal.component.html',
  styleUrls: ['./delete-user-confirmation-modal.component.scss'],
})
export class DeleteUserConfirmationModalComponent implements OnInit {
  @Input() selectedUser!: User;
  @Input() users!: User[];

  isEmailEntered: boolean = false;
  isDeleting: boolean = false;
  mail: string = '';

  constructor(
    private deleteService: DeleteService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {}

  delete() {
    this.isDeleting = true;
    if (this.selectedUser.id != undefined) {
      this.deleteService.deleteUser(this.selectedUser.id).subscribe(
        (response) => {
          let index: number = this.users.indexOf(this.selectedUser);
          if (index !== -1) {
            this.users.splice(index, 1);
            document.getElementById('closeConfirmationModalButton')?.click();
          }
          this.isDeleting = false;
          this.toastr.success(
            'User ' +
              this.selectedUser.displayName +
              ' is successfully deleted.',
            'Success'
          );
        },
        (error) => {
          this.isDeleting = false;
          this.toastr.error(
            'User ' +
              this.selectedUser.displayName +
              ' is not successfully deleted.',
            'Failure'
          );
        }
      );
    }
  }

  checkIfEmailEntered() {
    if (this.mail == this.selectedUser.mail) {
      this.isEmailEntered = true;
    } else {
      this.isEmailEntered = false;
    }
  }
}
